export class InvoiceAmount {
  currency: string;
  htAmount?: number;
  ttcAmount?: number;
  unitAmount: number;
  vatAmount?: number;
  vatRate?: number;

  constructor(values= {}) {
    Object.assign(this, values);
  }
}
